import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

// Only initialize analytics in production builds and in the browser.
if (typeof window !== "undefined" && process.env.NODE_ENV === "production") {
  const firebaseConfig = {
    apiKey: "AIzaSyDpzBD2SdFeaQC9gw6VqzEiwwVrVgJ7Mo4",
    authDomain: "appwhere-monitoring.firebaseapp.com",
    projectId: "appwhere-monitoring",
    storageBucket: "appwhere-monitoring.firebasestorage.app",
    messagingSenderId: "564142774629",
    appId: "1:564142774629:web:769c2307c6bef3adcd698c",
    measurementId: "G-264W81WXX8",
  };

  try {
    const app = initializeApp(firebaseConfig);
    const analytics = getAnalytics(app);

    window.AppwhereAnalytics = {
      logEvent: (name, params = {}) => {
        try {
          logEvent(analytics, name, params);
        } catch (e) {
          // Ignore analytics errors to avoid impacting user flow.
        }
      },
      logFrontendError: (area, details = {}) => {
        try {
          logEvent(analytics, "frontend_error", {
            area,
            ...details,
          });
        } catch (e) {
          // Ignore analytics errors to avoid impacting user flow.
        }
      },
    };
  } catch (error) {
    // Ignore initialization errors to avoid breaking the app.
  }
}
